import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Person as PersonIcon } from '@mui/icons-material';
import { useTranslation } from '../../../hooks/useTranslation';

const ClientSignUpHeader = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #f5f5dc 0%, #e8e8c8 100%)',
        p: { xs: 2, md: 4 },
        color: '#212121',
        textAlign: 'center',
        position: { xs: 'sticky', md: 'relative' },
        top: { xs: 0, md: 'auto' },
        zIndex: { xs: 10, md: 1 },
        boxShadow: { xs: '0 2px 10px rgba(0,0,0,0.1)', md: 'none' },
        flexShrink: 0
      }}
    >
      {/* Decorative elements pour desktop */}
      {!isMobile && (
        <>
          <Box
            sx={{
              position: 'absolute',
              top: -20,
              right: -20,
              width: 100,
              height: 100,
              borderRadius: '50%',
              background: 'rgba(33,33,33,0.05)',
              zIndex: 0
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              bottom: -30,
              left: -30,
              width: 120,
              height: 120,
              borderRadius: '50%',
              background: 'rgba(33,33,33,0.03)',
              zIndex: 0
            }}
          />
        </>
      )}
      
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Box
          sx={{
            width: { xs: 40, md: 60 },
            height: { xs: 40, md: 60 },
            borderRadius: '50%',
            background: 'rgba(33,33,33,0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mx: 'auto',
            mb: { xs: 1, md: 2 }
          }}
        >
          <PersonIcon sx={{ fontSize: { xs: 20, md: 30 }, color: '#212121' }} />
        </Box>
        
        <Typography 
          variant={isMobile ? "h6" : "h4"} 
          gutterBottom 
          sx={{ 
            fontWeight: 700,
            fontSize: { xs: '1rem', md: '2.125rem' },
            mb: { xs: 0.5, md: 1 }
          }}
        >
          {isMobile ? t('auth.clientAccount') : t('auth.createClientAccount')}
        </Typography>
        
        <Typography
          variant={isMobile ? "caption" : "body1"}
          sx={{
            opacity: 0.8,
            color: '#424242',
            fontSize: { xs: '0.75rem', md: '1rem' }
          }}
        >
          {t('auth.joinThousandsUsers')}
        </Typography>
      </Box>
    </Box>
  );
};

export default ClientSignUpHeader;